import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { toastr } from 'react-redux-toastr';
import CartShow from '../../components/cart/show';
import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';

import APP_ROUTES from '../../constants/app-routes';
import translations from '../../../translations/app-translations';
import refreshOrderProcess from '../../services/refresh-order-process';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    locale: state.locale,
    stores: state.stores.stores,
    disablingAdd: state.order.disablingAdd,
    currentZone: state.zones.currentZone,
    lineItemsError: state.error.errorLineItems,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'cart',
        });
    },
    refreshOrder: (cartOrder, locale) => {
        dispatch(Actions.refreshOrder(locale))
            .then((data) => {
                if (cartOrder.item_count !== data.body.data.attributes.item_count) {
                    toastr.warning(translations[locale]['warning-product-change-tittle'], translations[locale]['warning-product-change-content']);
                }
            })
            .catch((error) => {
                toastr.error(translations[locale].error, translations[locale]['error-reload-cart-order']);
                if (error.status === 404) {
                    dispatch(Actions.emptyCart(cartOrder, locale));
                    dispatch(push(APP_ROUTES.homePageRoute));
                }
            });
    },
    emptyCart: (order, locale) => {
        if (order.id) {
            dispatch(Actions.addingProductToCartFix(true));
            dispatch(Actions.emptyCart(order, locale)).finally(() => {
                dispatch(Actions.addingProductToCartFix(false));
                toastr.success(translations[locale].well, translations[locale]['cart-is-now-empty']);
            });
        } else {
            toastr.success(translations[locale].well, translations[locale]['cart-already-empty']);
        }
    },

    destroyLineItem: (lineItem, locale) => {
        dispatch(Actions.removingProductToCart(true));
        dispatch(Actions.removeProductFromCart(lineItem.id, locale)).then(() => {
            refreshOrderProcess(dispatch, locale, toastr, {
                addingProductToCartAction: false,
                successNotify: toastr.success(translations[locale].well, translations[locale]['item-removed-from-cart']),
            }).finally(() => {
                dispatch(Actions.removingProductToCart(false));
            });
        },
        (error) => {
            console.log(error);
            toastr.error(translations[locale].error, translations[locale]['item-not-removed-from-cart']);
            dispatch(Actions.removingProductToCart(false));
        });
    },

    destroyDataExtra: (extraDataId, locale) => {
        dispatch(Actions.removingProductToCart(true));
        dispatch(Actions.removeDataExtraFromCart(extraDataId, locale)).then(() => {
            refreshOrderProcess(dispatch, locale, toastr, {
                addingProductToCartAction: false,
                successNotify: toastr.success(translations[locale].well, translations[locale]['item-removed-from-cart']),
            }).finally(() => {
                dispatch(Actions.removingProductToCart(false));
            });
        },
        (error) => {
            console.log(error);
            toastr.error(translations[locale].error, translations[locale]['item-not-removed-from-cart']);
            dispatch(Actions.removingProductToCart(false));
        });
    },

    changeQuantity: (lineItemId, quantity, zoneId, locale) => {
        if (parseInt(quantity, 10) > 0) {
            dispatch(Actions.disablingAdd(false));
            dispatch(Actions.addingProductToCart());
            dispatch(Actions.changeProductQuantityFromCart(quantity, lineItemId, zoneId, locale)).then(() => {
                refreshOrderProcess(dispatch, locale, toastr, {
                    addingProductToCartAction: true,
                });
            },
            (error) => {
                dispatch(Actions.addingProductToCart());
                dispatch(Actions.disablingAdd(true));
                dispatch(Actions.changeProductQuantityFromCart(quantity - 1, lineItemId, zoneId, locale));
                toastr.error(translations[locale].error, translations[locale]['unable-update-product-quantity']);
            });
        } else {
            toastr.error(translations[locale].error, translations[locale]['quantity-greater-than-zero']);
        }
    },

    disablingPlus: (enabled) => dispatch(Actions.disablingAdd(enabled)),

    doCheckout: (order, locale) => {
        const orderStepIndex = order.checkout_steps.indexOf(order.state.trim());

        if (orderStepIndex > 0) {
            dispatch(push(APP_ROUTES.checkout[`${order.state}PageRoute`]));
        } else if (order.state === 'cart') {
            dispatch(Actions.goToNextStep(order, locale));
        } else {
            dispatch(push(APP_ROUTES.checkout.addressPageRoute));
        }
    },
});

const CartShowConnector = connect(mapStateToProps, mapDispatchToProps)(CartShow);

export default CartShowConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/cart/cart-show-connector.js
 **/